import axiosClient from "api/apiClient";

export function getFaq() {
  return axiosClient.get("/faq");
}
